var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 67,
    viewBox: "0 0 90 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1396 66.9167V26.9282L3.50092 37.1042L0.833252 33.6062L44.9999 0.666656L64.1948 14.9016V5.08332H72.5202V21.1512L89.2505 33.6062L86.5828 37.1042L72.9442 26.9282V66.9167H50.4324V43.8175H39.5586V66.9167H17.1396ZM21.5563 62.5H35.1508V39.4008H54.8579V62.5H68.5319V23.6775L44.9999 6.21399L21.5563 23.6775V62.5ZM37.0146 27.1932H52.9852C52.9852 25.1203 52.1858 23.414 50.587 22.0742C48.9911 20.7345 47.1287 20.0647 44.9999 20.0647C42.8711 20.0647 41.0087 20.7316 39.4128 22.0654C37.814 23.3992 37.0146 25.1114 37.0146 27.1932ZM35.1508 62.5V39.4008H54.8579H35.1463L35.1508 62.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.875f9da7215d8dabae61dc7c3a799bb7.svg";
export { ForwardRef as ReactComponent };